import { compose, withPropsOnChange } from 'recompose'
import { connect } from 'react-redux'
import withTranslations from '../../core/withTranslations'
import { getUserCharityId } from '../session/index'

const mapStateToProps = state => ({
  hasUserCharity: Boolean(getUserCharityId(state))
})

const withUserCharityData = connect(mapStateToProps)

const userMenuPath = 'app:menus.user'
const translate = withTranslations({
  profileText: `${userMenuPath}.profile`,
  addressesText: `${userMenuPath}.addresses`,
  favoritesText: `${userMenuPath}.favorites`,
  ordersText: `${userMenuPath}.orders`,
  charityAdminText: `${userMenuPath}.charityAdmin`,
  logoutText: `${userMenuPath}.logout`,
  charityInfoText: `${userMenuPath}.charityInfo`,
  draftEventsText: `${userMenuPath}.draftEvents`,
  publicEventsText: `${userMenuPath}.publicEvents`,
  createEventText: `${userMenuPath}.createEvent`
})

const withMenuItems = withPropsOnChange(['hasUserCharity'], props => {
  const {
    hasUserCharity,
    onLogoutClick,
    profileText,
    addressesText,
    //favoritesText,
    ordersText,
    charityAdminText,
    logoutText,
    charityInfoText,
    draftEventsText,
    publicEventsText,
    createEventText
  } = props
  let items = []
  items = items.concat([
    { icon: 'user-profile', text: profileText, url: '/myprofile' },
    { icon: 'map-pin', text: addressesText, url: '/myprofile/myaddresses' },
    // remove comment when Favorites / Saved features are finished
    // { icon: 'saved2', text: favoritesText, url: '/myprofile/favorites' },
    { icon: 'my-orders', text: ordersText, url: '/myprofile/myorders' }
  ])

  if (hasUserCharity) {
    items = items.concat([
      {
        icon: 'charity-admin',
        text: charityAdminText,
        url: '/mycharity'
      },
      {
        text: charityInfoText,
        className: 'simple-item',
        url: '/mycharity/info'
      },
      {
        text: draftEventsText,
        className: 'simple-item',
        url: '/mycharity/auctions/draft'
      },
      {
        text: publicEventsText,
        className: 'simple-item',
        url: '/mycharity/auctions/public'
      },
      {
        text: createEventText,
        className: 'simple-item',
        url: '/mycharity/auctions/new'
      }
    ])
  }

  items.push({
    icon: 'goback',
    text: logoutText,
    url: '/logout',
    onClick: onLogoutClick
  })

  return {
    items
  }
})

const decorate = compose(translate, withUserCharityData, withMenuItems)

export default decorate



// WEBPACK FOOTER //
// ./src/services/layout/UserMenu.js